<template>
  <div class="product-groups-slider">
    <ProductGroupsDesktopCarousel
      v-bind="$props"
    />
    <ProductGroupsMobileTiles
      v-bind="$props"
    />
  </div>
</template>
<script lang="ts">
import type { PropType } from 'vue';
import ProductGroupsDesktopCarousel from './ProductGroupsDesktopCarousel.vue';
import ProductGroupsMobileTiles from './ProductGroupsMobileTiles.vue';
import type { ProductGroupsItemType } from '~~/types/cms/ProductGroupsItem';

export default defineComponent({
  name: 'ProductGroupsSlider',
  components: { ProductGroupsDesktopCarousel, ProductGroupsMobileTiles },
  props: {
    items: {
      type: Array as PropType<Array<ProductGroupsItemType>>,
      required: true,
    },
    textColor: {
      type: String,
      default: 'text-EXPONDO-black',
    },
    backgroundColor: {
      type: String,
      default: 'bg-EXPONDO-grey-5',
    },
  },
});

</script>
